import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getAllTasks ({ }, patientAdmissionId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/patientadmissions/' + patientAdmissionId + '/tasks/_all')).data
      } catch (e) {
        throw e
      }
    },
    async getFilteredTasks ({ }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/task/_filter', options)).data
      } catch (e) {
        throw e
      }
    },
    async completeTask ({ }, options) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/tasks/complete/:' + options.id, options)).data
      } catch (e) {
        throw e
      }
    },
  }
}
